$(document).ready(function(){
    var item_ent = document.querySelectorAll('.order-summary__body .text-end .entries-value');
    var total_value = 0;
    for (let i = 0; i < item_ent.length; i++) {
        total_value += parseInt(item_ent[i].innerHTML.replace("Entries", ""));
    }
    document.querySelector('.cart-footer .entries-value').innerHTML = (total_value) + "Entries";

})


$(document).on('click', '.sr-only', function(){
    let sr_only_val = $(this).val();

    const show_entries = $(".entries-value.variant-select").data('show-entries');
    const multi = parseInt($(".entries-value.variant-select").data('settings-multi'));
    const multi_text = $(".entries-value.variant-select").data('settings-multi-text');

    for (let i = 0; i <  $('.variant-compare-option').length; i++) {
        let compare_val = $('.variant-compare-option').eq(i).val();
        let entrie_price = $('.variant-compare-option').eq(i).data('entrie-price');
        let variant_price = $('.variant-compare-option').eq(i).data('price');
        
        if(sr_only_val == compare_val){
            $('.pdp-price .price').html(variant_price);

            if(show_entries == true){
                $(".entries-value.variant-select").html( entrie_price * multi / 100 + " " + multi_text);
            }
        }
    }
})



